<footer class="footer">
  <span class="footer__text">
    {{ 'footer.made_with' | translate }}
    <rt-icon name="bravos-filled" class="footer__icon" />
    {{ 'footer.at' | translate }}
    <a href="https://tellent.com" target="_blank" rel="noopener noreferrer" class="footer__link">
      Tellent
    </a>
  </span>
</footer>
